var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 16C1.61602 16 1.14518 15.8042 0.753516 15.4125C0.361849 15.0208 0.166016 14.55 0.166016 14V2C0.166016 1.45 0.361849 0.979167 0.753516 0.5875C1.14518 0.195833 1.61602 0 2.16602 0H18.166C18.716 0 19.1868 0.195833 19.5785 0.5875C19.9702 0.979167 20.166 1.45 20.166 2V14C20.166 14.55 19.9702 15.0208 19.5785 15.4125C19.1868 15.8042 18.716 16 18.166 16H2.16602ZM10.166 9L2.16602 4V14H18.166V4L10.166 9ZM10.166 7L18.166 2H2.16602L10.166 7ZM2.16602 4V2V14V4Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bf2d3faaa433efa46134a735b3547f88.svg";
export { ForwardRef as ReactComponent };